module.exports = __webpack_public_path__ + "static/media/logo2.d7dc01a0.svg";